var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/macros/product-author-macros.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["review", "product"], 
[], 
function (l_review, l_product, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("review", l_review);
frame.set("product", l_product);
var t_2 = "";var t_3;
t_3 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_product),"productReviews")),"Includes")),"Authors")),runtime.memberLookup((l_review),"AuthorId"));
frame.set("author", t_3, true);
if(frame.topLevel) {
context.setVariable("author", t_3);
}
if(frame.topLevel) {
context.addExport("author", t_3);
}
var t_4;
t_4 = "product_reviews";
frame.set("badgeNamespace", t_4, true);
if(frame.topLevel) {
context.setVariable("badgeNamespace", t_4);
}
if(frame.topLevel) {
context.addExport("badgeNamespace", t_4);
}
var t_5;
t_5 = [(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"Badges")),"Staff")),"Id"))),(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"Badges")),"featured")),"Id"))),(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"Badges")),"top1")),"Id"))),(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"Badges")),"top10")),"Id"))),(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"Badges")),"top25")),"Id"))),(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"Badges")),"top50")),"Id"))),(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"Badges")),"top100")),"Id"))),(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"Badges")),"top250")),"Id"))),(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"Badges")),"top500")),"Id"))),(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"Badges")),"top1000")),"Id")))];
frame.set("reviewerBadgeData", t_5, true);
if(frame.topLevel) {
context.setVariable("reviewerBadgeData", t_5);
}
if(frame.topLevel) {
context.addExport("reviewerBadgeData", t_5);
}
var t_6;
t_6 = (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"heightFeet")),"ValueLabel")?runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"heightFeet")),"ValueLabel") + "&#39;":"");
frame.set("heightFeet", t_6, true);
if(frame.topLevel) {
context.setVariable("heightFeet", t_6);
}
if(frame.topLevel) {
context.addExport("heightFeet", t_6);
}
var t_7;
t_7 = (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"heightInches")),"ValueLabel")?" " + runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"heightInches")),"ValueLabel") + "&#34;":"");
frame.set("heightInches", t_7, true);
if(frame.topLevel) {
context.setVariable("heightInches", t_7);
}
if(frame.topLevel) {
context.addExport("heightInches", t_7);
}
var t_8;
t_8 = [{"labelSlug": "product_reviews-location-label","fieldValue": runtime.memberLookup((l_review),"UserLocation")},{"labelSlug": "product_reviews-age-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"age")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"Age")),"ValueLabel"))},{"labelSlug": "product_reviews-beauty-style-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"beautyStyle")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"BeautyStyle")),"ValueLabel"))},{"labelSlug": "product_reviews-eye-color-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"eyeColor")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"EyeColor")),"ValueLabel"))},{"labelSlug": "product_reviews-hair-texture-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"hairTexture")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"HairTexture")),"ValueLabel"))},{"labelSlug": "product_reviews-hair-type-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"hairType")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"HairType")),"ValueLabel"))},{"labelSlug": "product_reviews-hair-concern-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"hairConcern")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"HairConcern")),"ValueLabel"))},{"labelSlug": "product_reviews-home-type-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"homeType")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"HomeType")),"ValueLabel"))},{"labelSlug": "product_reviews-room-type-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"roomType")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"RoomType")),"ValueLabel"))},{"labelSlug": "product_reviews-home-personal-style-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"homePersonalStyle")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"HomePersonalStyle")),"ValueLabel"))},{"labelSlug": "product_reviews-skin-tone-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"skinTone")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"SkinTone")),"ValueLabel"))},{"labelSlug": "product_reviews-skin-type-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"skinType")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"SkinType")),"ValueLabel"))},{"labelSlug": "product_reviews-skin-concern-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"skinConcern")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"SkinConcern")),"ValueLabel"))},{"labelSlug": "product_reviews-body-type-label","fieldValue": (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"bodyType")),"ValueLabel") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"bodytype")),"ValueLabel"))},{"labelSlug": "product_reviews-height-label","fieldValue": runtime.contextOrFrameLookup(context, frame, "heightFeet") + runtime.contextOrFrameLookup(context, frame, "heightInches")},{"labelSlug": "product_reviews-style-label","fieldValue": runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_review),"ContextDataValues")),"style")),"ValueLabel")}];
frame.set("reviewerInfoData", t_8, true);
if(frame.topLevel) {
context.setVariable("reviewerInfoData", t_8);
}
if(frame.topLevel) {
context.addExport("reviewerInfoData", t_8);
}
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "reviewerBadgeData");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("badgeId", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
if(t_12) {
t_2 += "<p class=\"c-product-review__user-badge\">\n                ";
t_2 += runtime.suppressValue((lineno = 66, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "badgeNamespace") + "" + "-" + "" + t_12 + "" + "Contributor"])), env.opts.autoescape);
t_2 += "\n            </p>";
;
}
;
}
}
frame = frame.pop();
t_2 += "\n    <div class=\"c-product-review__user-info-inner\" data-qa-review-user-info>";
frame = frame.push();
var t_15 = runtime.contextOrFrameLookup(context, frame, "reviewerInfoData");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("reviewerInfo", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
if(runtime.memberLookup((t_16),"fieldValue")) {
t_2 += "<p class=\"c-product-review__user-info\">\n                    <span class=\"c-product-review__user-info--label\">";
t_2 += runtime.suppressValue((lineno = 76, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((t_16),"labelSlug")])), env.opts.autoescape);
t_2 += ":</span> ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_16),"fieldValue")), env.opts.autoescape);
t_2 += "\n                </p>";
;
}
;
}
}
frame = frame.pop();
t_2 += "</div>";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("displayAuthorInfo");
context.setVariable("displayAuthorInfo", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/macros/product-author-macros.j2"] , dependencies)